import { authApiService } from '../services/auth-api.service.js'
import userRoles from '@/constants/userRoles.js'

export default {
    _user: null,
    _roles: null,
    _includesLimits: null,

    async initialise(user) {
        if (!user)
            throw 'User cannot be null!';

        this._includesLimits = true;
        this._user = user;
        await this.getRolesToken();
        const roles = this._getClaimFromRolesToken('http://schemas.microsoft.com/ws/2008/06/identity/claims/role')
        try {
            if (Array.isArray(roles)) {
                this._roles = roles.map(r => JSON.parse(r));
            } else {
                this._roles = JSON.parse(roles);
            }
        } catch (err) {
            console.log(`adminUser initialise error ${err}`)
        }

    },

    async getRolesToken() {
        try {
            var response = await authApiService.GetRolesTokenForUser();
            this._setCachedRolesToken(response.data);
            return true;
        }
        catch (error) {
            console.error(error)
            return false;
        }
    },

    username() {
        if (this._user && this._user.hasOwnProperty('userName')) {
            return this._user.userName;
        }
        return null;
    },

    identityId() {
        if (this._user && this._user.hasOwnProperty('profile')) {
            if (this._user.profile && this._user.profile.hasOwnProperty('oid')) {
                return this._user.profile.oid;
            }
        }
        return null;
    },

    fullname() {
        return this._user.profile.name;
    },

    firstname() {
        return this._user.profile.given_name;
    },

    lastname() {
        return this._user.profile.family_name;
    },

    isUser() {
        return this.hasRole(userRoles.USER);
    },

    isSystemAdmin() {
        return this.hasRole(userRoles.SYS_ADMIN)
    },

    isReadonly() {
        return this.hasRole(userRoles.READONLY);
    },

    isClaimAgent() {
        return this.hasRole(userRoles.CLAIMS_AGENT) || this.hasRole(userRoles.CLAIMS_AGENT_SENIOR);
    },

    isClaimTeamLeader() {
        return this.hasRole(userRoles.CLAIMS_TEAM_LEADER);
    },

    isClaimManager() {
        return this.hasRole(userRoles.CLAIMS_MANAGER);
    },

    getPaymentApprovalLimit() {
        if (this._roles) {
            if (Array.isArray(this._roles)) {
                return Math.max(...this._roles.map(o => o.roleLimits.paymentLimit))
            } else {
                return Math.max(this._roles.roleLimits.paymentLimit)
            }
        }
        return 0;
    },

    canManuallyReCalculateXs() {
        return this.hasRole(userRoles.CALC_EXCESS)
    },

    hasRole(roleId) {
        let roles = this._getClaimFromRolesToken('http://schemas.microsoft.com/ws/2008/06/identity/claims/role')

        try {
            if (Array.isArray(roles)) {
                this._roles = roles.map(r => JSON.parse(r));
            } else {
                this._roles = JSON.parse(roles);
            }
        } catch (err) {
            console.log(`adminUser hasRole error ${err}`)
        }

        if (this._roles && roles.length > 0) {
            let hasRole = false
            if (Array.isArray(this._roles)) {
                hasRole = this._roles.find(function (element) {
                    if (/*this._includesLimits*/ true) {
                        //element = JSON.parse(element);
                        return element.roleId == roleId;
                    } else
                        return element == roleId;
                })
            } else {
                if (/*this._includesLimits*/ true) {
                    //roles = JSON.parse(element)
                    hasRole = this._roles.roleId == roleId
                } else
                    hasRole = this._roles == roleId
            }
            if (hasRole) {
                return true
            }
        }
        return false
    },

    _setCachedRolesToken(token) {
        localStorage.setItem("taurus-admin-roles", token);
    },

    _getCachedRolesToken() {
        return localStorage.getItem('taurus-admin-roles')
    },

    _parseCachedRolesToken() {
        let token = this._getCachedRolesToken()

        if (token) {
            return this._parseJwt(token)
        }

        return null
    },

    _parseJwt(token) {
        var base64Url = token.split('.')[1]
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        return JSON.parse(window.atob(base64))
    },

    _getClaimFromRolesToken(claimName) {
        let parsedToken = this._parseCachedRolesToken()
        //console.log(parsedToken)
        if (parsedToken) {
            return parsedToken[claimName]
        }

        return null
    }
};